import { AbstractControl, ValidationErrors, Validator } from '@angular/forms';
import { ElementRef, Injectable } from '@angular/core';
import { DatePicker } from '@vaadin/date-picker';
import { fromPairs } from 'lodash';


@Injectable()
export class DatePickerValidator implements Validator {
	constructor(private readonly host: ElementRef<DatePicker>) {}
	
	public validate(control: AbstractControl): ValidationErrors | null {
		if (this.host.nativeElement.validate()) {
			return null;
		} else {
			return fromPairs(Array.from(this.errors()));
		}
	}
	
	private* errors(): Generator<[string, string], void, void> {
		const picker = this.host.nativeElement;
		
		if (picker.required && !picker.value) {
			yield ['required', 'datepicker.error.empty'];
		}
		
		if (picker.value) {
			yield ['invalid', 'datepicker.error.invalid'];
		}
	}
}